<template>
	<div class="summary">
		<!-- {{{ render_paypalplus }}} -->
		<h2>Resumen</h2>
		<div class="table-responsive">
			<div v-if="!render_products.length">
				<p class="text-general text-padding-left">Tu carrito de compras está vacío. Navega por nuestro <a v-link="{ path: '/almacenamiento?page=1' }">Catálogo en Línea</a> para agregarle productos.</p>
			</div>
			<table class="table" v-if="render_products.length">
				<thead>
					<tr>
						<th>Nombre</th>
						<th>Imágen</th>
						<th>Descripción</th>
						<th>Cantidad</th>
						<th>Precio Unitario</th>
						<th>Subtotal</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="product_cart in render_products">
						<td>
							{{ product_cart.product.name }}
						</td>
						<td>
							<img :src="getMainImage(product_cart.product)" alt="Main image">
						</td>
						<td>
							<p>Tamaño:</p>
							<p><strong>{{ getSize(product_cart) }}</strong></p>
							<p>Color:</p>
							<div class="admin-span-color color-border" :style="`background-color: ${ product_cart.product.color }`"></div>
							<div v-if="product_cart.product.color2" class="admin-span-color color-border" :style="`background-color: ${ product_cart.product.color2 }`"></div>
						</td>
						<td>
							{{ product_cart.quantity }}
							<!-- <input type="number" class="form-control" v-model="product_cart.quantity" disabled> -->
						</td>
						<td v-if="!product_cart.variation || product_cart.variation == 'M'">${{ accounting.formatMoney((product_cart.product.price).toFixed(2), '') }}</td>
						<td v-if="!product_cart.variation || product_cart.variation == 'M'">${{ accounting.formatMoney((product_cart.product.price * product_cart.quantity).toFixed(2), '') }}</td>
						<td v-if="product_cart.variation == 'S'">${{ accounting.formatMoney((product_cart.product.price_S).toFixed(2), '') }}</td>
						<td v-if="product_cart.variation == 'S'">${{ accounting.formatMoney((product_cart.product.price_S * product_cart.quantity).toFixed(2), '') }}</td>
						<td v-if="product_cart.variation == 'L'">${{ accounting.formatMoney((product_cart.product.price_L).toFixed(2), '') }}</td>
						<td v-if="product_cart.variation == 'L'">${{ accounting.formatMoney((product_cart.product.price_L * product_cart.quantity).toFixed(2), '') }}</td>
					</tr>
				</tbody>
			</table>
		</div>
		<div class="row" v-if="render_products.length">
			<div class="col-sm-4">
				<div class="col-sm-12">
					<h2 class="text-uppercase no-margin-top">Dirección</h2>
					<div class="col-sm-6" v-if="render_address.id">
						<div class="address-container">
							<p class="text-general">Nombre:</p>
							<p class="strong">{{ render_address.first_name }}</p>
							<p class="text-general">Calle:</p>
							<p class="strong">{{ render_address.street }}</p>
							<p class="text-general">Colonia:</p>
							<p class="strong">{{ render_address.suburb }}</p>
						</div>
					</div>
					<div class="col-sm-6" v-if="render_address.id">
						<p class="text-general">Apellidos:</p>
						<p class="strong">{{ render_address.last_name }}</p>
						<p class="text-general">Ciudad:</p>
						<p class="strong">{{ render_address.city.nom_mun }}</p>
						<p class="text-general">N° ext:</p>
						<p class="strong">{{ render_address.ext_number }}</p>
						<p class="text-general">CP:</p>
						<p class="strong">{{ render_address.postal_code }}</p>
					</div>
					<div class="col-sm-6">
						<p class="text-general" v-if="!render_address.id">Agrega una dirección.</p>
					</div>
				</div>
			</div>

      <div class="col-sm-4">
        <h2 class="text-uppercase">Método de pago</h2>
        <div class="col-sm-12">
          <div class="col-sm-11">
            <div class="address-container">
              <div class="text-general">{{ render_shopping_payment }}</div>
              <p class="text-general" v-if="!render_shopping_payment">
                Selecciona un método de pago.
              </p>
            </div>
          </div>
        </div>
      </div>

			<!-- <div class="col-sm-4">
				<div class="col-sm-12">
					<h2 class="text-uppercase no-margin-top">Método de envío</h2>
					<div class="col-sm-11">
						<div class="address-container">
							<p class="text-general">{{ render_shopping_method }}</p>
							<p class="text-general" v-if="!render_shopping_method">
								Selecciona un método de envío.
							</p>
						</div>
					</div>
				</div>
			</div>	 -->

			<div class="col-sm-4 no-padding-right">
				<div class="form-horizontal form-payment no-padding-right" role="form">
					<div class="form-group">
					    <label class="control-label col-sm-4" for="name">Subtotal</label>
					    <div class="col-sm-8">
					      <input type="text" class="form-control" v-model="render_subtotal" disabled id="subtotal">
					    </div>
				 	</div>
					<div class="form-group">
						<label class="control-label col-sm-4" for="coupon">Descuento cupón</label>
						<div class="col-sm-8">
						  <input type="text" class="form-control" v-model="render_discount" disabled id="coupon">
						</div>
					</div>
					<div class="form-group">
						<label class="control-label col-sm-4" for="total">Total</label>
						<div class="col-sm-8">
						  <input type="text" class="form-control" v-model="render_total" disabled id="total">
						</div>
					</div>
					<div class="form-group" v-if="shopping_cart_shipping != 2">
						<label class="control-label col-sm-4" for="total">Costo de envío</label>
						<div class="col-sm-8">
						  <input type="text" class="form-control" v-model="render_shipping" disabled id="total">
						</div>
					</div>
					<div class="form-group">
						<label class="control-label form-label-strong col-sm-4" for="total">Total a pagar</label>
						<div class="col-sm-8">
						  <input type="text" class="form-control" v-model="render_total_iva" disabled id="total">
						</div>
					</div>
					<div class="form-group" v-if="shopping_cart_shipping == 2">
						<label class="control-label col-sm-4" for="total">Costo de envío aproximado</label>
						<div class="col-sm-8">
						  <input type="text" class="form-control" v-model="render_shipping" disabled id="total">
						</div>
					</div>
					<div class="form-group">
						<div class="col-sm-8 col-sm-offset-4">
							<button class="btn btn-black btn-lg btn-shop" @click="checkout">Proceder a comprar</button>
							<div class="error text-center" v-if="has_error">{{ error_msg }}</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div class="modal-paypalplus modal-umbrella" :class="{ active: show_modal }">
		<input type="hidden" :value="render_paypalplus">
		<div class="modal-paypalplus-content" @click="notCloseModal($event)">
			<div id="ppplus"></div>
			<p class="text-center">No recargue la pagina o cambie la url hasta terminar el proceso de compra.</p>
			<div class="paypalplus-continue">
				<input type="submit" id="continue" class="btn btn-black" value="Continuar" @click="submitPayPal()">
			</div>
		</div>
	</div>

	<loader-full v-if="is_submited"></loader-full>
</template>

<style scoped>
	label,
	.form-payment .control-label{
		font-size: 12px;
	}
	h2{
		margin-bottom: 0;
	}
</style>

<script>
import { checkoutShoppingCart } from '../../store/actions';
import { toast } from '../../scripts/toast';
import LoaderFull from '../../components/Loader-full.vue';
import default_image from '../../images/default.jpg';
import accounting from '../../scripts/accounting';
import { api_base } from '../../store/api';

export default {
	// ---- DATA ----

	data() {
		return {
			error_msg: null,
			has_error: false,
			is_submited: false,
			image: default_image,
			subtotal_string: '',
			ppp: {},
			show_modal: false,
			accounting
		}
	},

	// ---- VUEX ----

	vuex: {
		getters: {
			html: state => state.html,
			user: state => state.current_user,
			promo_code: state => state.promo_code,
			fedex_quote: state => state.fedex_quote,
			national_quote: state => state.national_quote,
			shopping_cart_address: state => state.shopping_cart_address,
			shopping_cart_shipping: state => state.shopping_cart_shipping,
			shopping_cart_payment: state => state.shopping_cart_payment,
			shopping_cart_index: state => state.shopping_cart_index,
			shopping_cart: state => {
				let products = state.products;
				let shopping_cart = state.shopping_cart;

				if (products && shopping_cart.products)
					for (let i = 0; i < products.length; i++) {
						for (let j = 0; j < shopping_cart.products.length; j++) {
							if (products[i].id == shopping_cart.products[j].product_id) {
								shopping_cart.products[j].product.images = products[i].images;
							}
						}
					}

				return shopping_cart;
			},
		},
		actions: {
			checkoutShoppingCart
		}
	},

	// ---- METHODS ----

	methods: {
		notCloseModal(e) {
			e.stopPropagation();
		},

		checkout() {
			this.error_msg = null;
			this.has_error = false;

			// if aren't products in the shopping cart, show an alert.
			if (!this.shopping_cart.products.length) {
				return toast({
					title: 'Carrito de Compras',
					content: 'No hay productos en el carrito agrega algunos'
				});
			}

			/* Initialize the params to send in the
			checkout request. */
			let params = {
				will_be_delivered: 0,
				// shippment_type: null,
				shipping_address: this.shopping_cart_index,
				method: null
      };

			/* Select shippment type string option to send as
			param in the checkout request. */
			// switch(this.shopping_cart_shipping) {
			// 	case '1':
			// 		params.shippment_type = 'fedex';
			// 		params.will_be_delivered = 1;
			// 		break;
			// 	case '2':
			// 		params.shippment_type = 'shippment_company'; // Not implemented.
			// 		params.will_be_delivered = 1;
			// 		break;
			// 	case '3':
			// 		params.shippment_type = 'pickup';
			// 		break;
			// 	case '4':
			// 		params.shippment_type = 'metro_zone';
			// 		params.will_be_delivered = 1;
			// 		break;
			// }
			/* Select payment method string to send as
			param in the checkout request. */
			switch(this.shopping_cart_payment) {
				case '1':
					params.method = 'bancomer'; // Not implemented.
					break;
				case '2':
					params.method = 'paypal';
					break;
				case '3':
					params.method = 'deposit'; // Not implemented.
					break;
				case '4':
					params.method = 'marcadopago'; // Not implemented.
					break;
				case '5':
					params.method = 'cash';
					break;
				case '6':
					params.method = 'paypalplus';
					break;
			}

			// check if the user insert a promo code, and if he does,
			// add to params to apply the code.
			if (this.promo_code.id) {
				params.promo_code = this.promo_code;
			}

			this.validate(params);

			if (this.has_error) {
				return;
			}

			/* Only send the shippment type and shippment address
			if the will_be_delivered is equal to 0. */
			this.is_submited = true;
			this.checkoutShoppingCart(this.user, params, this);
		},

		validate(params) {
			let obj_empty = true;

			if (!params.method) {
				this.error_msg = 'Elije un método de pago.';
				this.has_error = true;
			}

			// if (!params.shippment_type) {
			// 	this.error_msg = 'Elije un método de envío.';
			// 	this.has_error = true;
			// }

			for (let k in this.shopping_cart_address) {
				obj_empty = false;
			}

			if (obj_empty) {
				this.error_msg = 'Agrega una dirección.';
				this.has_error = true;
			}
		},

		getPrice() {
			let price_wrapper = 0;

			for (var i = 0, p = this.shopping_cart.products; i < p.length; i++) {
				switch (p[i].variation) {
					case 'S':
						price_wrapper += p[i].product.price_S * p[i].quantity;
						break;
					case 'L':
						price_wrapper += p[i].product.price_L * p[i].quantity;
						break;
					default:
						price_wrapper += p[i].product.price * p[i].quantity;
				}
			}

			return price_wrapper.toFixed(2);
		},

		getSize (p) {
			switch (p.variation) {
				case 'S':
					return 'Large';
				case 'L':
					return 'Extra Large';
				default:
					return 'Standard';
			}
		},

		getMainImage (product) {
			if (product.images.length) {
				return product.images[0].route
			}

			return this.image;
		},

		submitPayPal () {
			this.ppp.doContinue();
		},
	},

	// ---- RENDER ----

	computed: {
		render_user() {
			return this.user.user;
		},

		render_products() {
			if (this.shopping_cart && this.shopping_cart.products) {
				return this.shopping_cart.products;
			}

			return [];
		},

		render_address() {
			return this.shopping_cart_address || {};
		},

		render_shopping_payment() {
			switch (this.shopping_cart_payment) {
				case '1':
					return 'Tarjeta débito/crédito';
				case '2':
					return 'PayPal';
				case '3':
					return 'Transferencia/Depósito';
				case '4':
					return 'Mercado pago';
				case '5':
					return 'Efectivo';
				case '6':
					return 'Tarjeta débito/crédito (powered by PayPal)'
			}
		},

		render_shopping_method() {
			switch (this.shopping_cart_shipping) {
				case '1':
					return 'Fedex';
				case '2':
					return 'Paquetería';
				case '3':
					return 'Showroom';
				case '4':
					return 'Entrega a domicilio';
			}
		},

		render_subtotal() {
			if (this.shopping_cart && this.shopping_cart.products) {
				this.subtotal_string = '$ ' + accounting.formatMoney(this.getPrice(), '');
				return this.subtotal_string;
			}

			return '$ 0.00';
		},

		render_discount() {
			if (this.promo_code.discount) {
				if (this.promo_code.is_percentage == '1') {
					return (this.promo_code.discount * 100) + '%';
				} else {
					return '$ ' + accounting.formatMoney(this.promo_code.discount.toFixed(2), '');
				}
			}

			return '$ 0.00';
		},

		render_total() {
			let total = 0;
			// Render the total, iterate in all the products to obtain the total.
			if (this.shopping_cart && this.shopping_cart.products) {
				total = this.getPrice();
				if (this.promo_code.discount) {
					if (this.promo_code.is_percentage == '1') {
						total -= (total * this.promo_code.discount);
					} else {
						total -= this.promo_code.discount;
					}
				}

				if (total < 0) {
					total = 0;
				}

				return '$ ' + accounting.formatMoney(parseFloat(total).toFixed(2), '');
			}

			return '$ 0.00';
		},

		render_shipping() {
			// Check if the shipping type select is fedex, if
			// is this, return the fedex quote.
			// if (this.shopping_cart_shipping == 1) {
			// 	return '$ ' + accounting.formatMoney(parseFloat(this.fedex_quote).toFixed(2), '');
			// }
			// if (this.shopping_cart_shipping == 2) {
			// 	return '$ ' + accounting.formatMoney(parseFloat(this.national_quote).toFixed(2), '');
      // }
      if (this.national_quote) {
        return '$ ' + accounting.formatMoney(parseFloat(this.national_quote).toFixed(2), '');
      }

			return 'Gratis';
		},

		render_total_iva() {
			let total = 0;

			if (this.shopping_cart &&  this.shopping_cart.products && this.national_quote/* (this.shopping_cart_shipping == 1 || this.shopping_cart_shipping == 2) */) {
				// if (this.shopping_cart_shipping == 1) {
				// 	total = (parseFloat(this.getPrice()) + parseFloat(this.fedex_quote)).toFixed(2);
				// } else if (this.shopping_cart_shipping == 2) {
				// 	total = parseFloat(this.getPrice());
        // }
        total = parseFloat(this.getPrice()) + parseFloat(this.national_quote);
				if (this.promo_code.discount) {
					if (this.promo_code.is_percentage == '1') {
						total -= (this.getPrice() * this.promo_code.discount);
					} else {
						total -= this.promo_code.discount;
					}
				}
				if (total < 0) {
					total = 0;
        }

				return '$ ' + accounting.formatMoney(parseFloat(total).toFixed(2), '');
			} else if (this.shopping_cart && this.shopping_cart.products) {
				total = this.getPrice();

				if (this.promo_code.discount) {
					if (this.promo_code.is_percentage == '1') {
						total -= (total * this.promo_code.discount);
					} else {
						total -= this.promo_code.discount;
					}
				}

				if (total < 0) {
					total = 0;
				}

				return '$ ' + accounting.formatMoney(parseFloat(total).toFixed(2), '');
			} else {
        return '$ 0.00';
      }
		},

		// render_html() {
		// 	if (this.html) {
		// 		setTimeout(() => {
		// 			document.vbridge.submit();
		// 		}, 1000);
		// 	}

		// 	return this.html;
		// },

		render_paypalplus() {
			if (this.html && $('#ppplus')[0]) {
				var redirect = this.html.redirect;
				this.show_modal = true;
				this.ppp = PAYPAL.apps.PPP({
					"approvalUrl" : redirect.approvalUrl,
					"disallowRememberedCards" : true,
					"placeholder" : "ppplus",
					"enableContinue" : "continue",
					"onContinue" : function(rememberCardToken,payerId,ecToken) {
						window.location = api_base + '/paypal/execPayment?success=true&PayerID=' + payerId + '&paymentId=' + redirect.paymentId
						// TODO: action checkout.
					},
					"mode" : "live",
					"payerFirstName" : redirect.payerFirstName,
					"payerLastName" : redirect.payerLastName,
					"payerEmail" : redirect.payerEmail,
					"payerTaxId" : "",
					"country" : "MX",
					"language" : "ex_MX",
				});
			} else {
				this.show_modal = false;
			}

			return this.html
		},
	},

	// ---- COMPONENTS ----

	components: {
		LoaderFull
	}
}
</script>



// WEBPACK FOOTER //
// Shopping-cart-summary.vue?60d67359